export default {"src":"/_next/static/media/cypress-checkmark-icon.293f8ad0.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};